import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import { AnimationSettingsModel } from '@syncfusion/ej2-react-popups';
import React, { Component } from 'react';
import  { all_information, loadingShow } from '../../../App';
import Message from '../../../utils/Message/Message';
import {
  addTrainingSettings,
  deleteTrainingSettings,
  editTrainingSettings,
  getTrainingSettings,
} from '../../../services/Position/PositionServices';
interface IProps {}
interface IState {
  PositionsData: Array<any>;
}
class Positions extends Component<IProps, IState> {
  private type: string = 'position';
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    'Search',
  ];
  public validationRule: Object = { required: true };
  public validationNumberRule: Object = { required: true, number: true };
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  private animationSettings: AnimationSettingsModel;
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 20,
    pageCount: 10,
  };
  public editOptions: EditSettingsModel = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: true,
    newRowPosition: 'Top',
  };
  private gridPositionsObj: any;
  constructor(props: IProps) {
    super(props);
    this.state = {
      PositionsData: [],
    };
    this.animationSettings = { effect: 'Zoom', duration: 400, delay: 0 };
  }
  async getPositions() {
    await getTrainingSettings(this.type).then((res) => {
      let model = res.data.map((items: any) => {
        return {
          ...items,
        };
      });
      this.setState({ PositionsData: model });
    });
  }
  actionBeginPosition(args: any) {
    if (args.action === 'add') {
      this.savePointAddPositions(args.data);
    } else if (args.action === 'edit') {
      this.savePointEditPositions(args.data);
    } else if (args.requestType === 'delete') {
      this.savePointDeletePositions(args.data);
    }
  }
  componentDidMount() {
    this.getPositions();
  }
  savePointAddPositions(obje: any) {
    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      name: obje.name,
      description: obje.description,
      created_by: all_information.user_id,
      type: this.type,
    });
    //(obj);

    addTrainingSettings(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getPositions();
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointEditPositions(obje: any) {
    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      name: obje.name,
      description: obje.description,
      created_by: all_information.user_id,
      ID: obje.ID,
      type: this.type,
    });
    editTrainingSettings(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getPositions();
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointDeletePositions(obje: any) {
    const obj = JSON.stringify({
      ID: obje[0].ID,
    });
    deleteTrainingSettings(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getPositions();
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  private toolbarClick(args: any) {
    if (args.item.id === 'refresh') {
      this.getPositions();
    }
    if (this.gridPositionsObj && args.item.id === 'gridPositions_excelexport') {
      this.gridPositionsObj.excelExport();
    }
  }
  render() {
    return (
      <div>
        <GridComponent
          id='gridPositions'
          dataSource={this.state.PositionsData}
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          ref={(g) => (this.gridPositionsObj = g)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          allowExcelExport={true}
          showColumnChooser
          pageSettings={this.pageOptions}
          toolbarClick={this.toolbarClick.bind(this)}
          showColumnMenu={true}
          // enablePersistence
          allowResizing={true}
          allowGrouping={true}
          style={{ display: 'inline-block' }}
          gridLines='Both'
          height='calc(-220px + 100vh)'
          actionBegin={this.actionBeginPosition.bind(this)}
        >
          <ColumnsDirective>
            <ColumnDirective
              field='name'
              validationRules={this.validationRule}
              headerText='Name'
            />
            <ColumnDirective
              field='description'
              validationRules={this.validationRule}
              headerText='Description'
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              Page,
              ColumnChooser,
              ExcelExport,
              ColumnMenu,
              Resize,
              Group
            ]}
          />
        </GridComponent>
      </div>
    );
  }
}
export default Positions;
